import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line
export function SearchIcon(props) {
    return (_jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: 512, height: 512 }, props, { children: _jsx("path", { d: "m24 22.586-6.262-6.262a10.016 10.016 0 1 0-1.414 1.414L22.586 24ZM10 18a8 8 0 1 1 8-8 8.009 8.009 0 0 1-8 8Z", "data-name": "01 align center" }) })));
}
//# sourceMappingURL=SearchIcon.js.map